export const getPartiesParams = ({
  name = "",
  idQuery = "",
  companyRegQuery = "",
  query = "",
  number = 1,
  size = 10,
}) =>
  `?nameQuery=${name}&idQuery=${idQuery}&companyRegQuery=${companyRegQuery}&query=${query}&page=${number}&size=${size}`;
